module.exports = __webpack_public_path__ + "img/t2-22.272d1f4a.svg";